/**
 * Converts an array of {x,y} point objects to a DataXY object.
 * @param points - array of {x,y} point objects.
 */
export function xyObjectToXY(points) {
    return {
        x: points.map((entry) => entry.x),
        y: points.map((entry) => entry.y),
    };
}
//# sourceMappingURL=xyObjectToXY.js.map